import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { derinColors } from "./theme";

interface VerticalBarProps {
  height?: string;
  color?: string;
  sx?: SxProps<Theme>;
}

const VerticalBar: React.FC<VerticalBarProps> = ({
  height = "32px",
  color = derinColors.primaryDark,
  sx,
}) => (
  <Box
    sx={{
      width: "4px",
      height,
      background: color,
      borderRadius: "10px",
      flexShrink: 0,
      ...sx,
    }}
  />
);

export default VerticalBar;
